import { render, staticRenderFns } from "./ep_select_value_label.vue?vue&type=template&id=03aa9c6e&scoped=true"
import script from "./ep_select_value_label.vue?vue&type=script&lang=js"
export * from "./ep_select_value_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa9c6e",
  null
  
)

export default component.exports